import headingWidget from '../widgets/heading'
import textEditorWidget from '../widgets/text-editor'
import imageWidget from '../widgets/image'
import buttonWidget from '../widgets/button'
import dividerWidget from '../widgets/divider'
import spacerWidget from '../widgets/spacer'
import videoWidget from '../widgets/video'
import iconWidget from '../widgets/icon'
import iconBoxWidget from '../widgets/icon-box'
import imageBoxWidget from '../widgets/image-box'
import counterWidget from '../widgets/counter'
import countdownWidget from '../widgets/countdown'
import testimonialWidget from '../widgets/testimonial'
import tabsWidget from '../widgets/tabs'
import accordionWidget from '../widgets/accordion'
import alertWidget from '../widgets/alert'
import socialIconsWidget from '../widgets/social-icons'
import googleMapsWidget from '../widgets/google-maps'
import priceTableWidget from '../widgets/price-table'
import priceListWidget from '../widgets/price-list'
import flipBoxWidget from '../widgets/flip-box'
import callToActionWidget from '../widgets/call-to-action'
import animatedHeadlineWidget from '../widgets/animated-headline'
import starRatingWidget from '../widgets/star-rating'
import progressBarWidget from '../widgets/progress-bar'
import carouselWidget from '../widgets/carousel'
import galleryWidget from '../widgets/gallery'
import customHtmlWidget from '../widgets/custom-html'

const widgets = [
  headingWidget,
  textEditorWidget,
  imageWidget,
  buttonWidget,
  dividerWidget,
  spacerWidget,
  videoWidget,
  iconWidget,
  iconBoxWidget,
  imageBoxWidget,
  counterWidget,
  countdownWidget,
  testimonialWidget,
  tabsWidget,
  accordionWidget,
  alertWidget,
  socialIconsWidget,
  googleMapsWidget,
  priceTableWidget,
  priceListWidget,
  flipBoxWidget,
  callToActionWidget,
  animatedHeadlineWidget,
  starRatingWidget,
  progressBarWidget,
  carouselWidget,
  galleryWidget,
  customHtmlWidget,
]

export default function elementorWidgets(editor) {
  widgets.forEach(register => register(editor))
}
